import {
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_FAIL,
  VEHICLE_DETAILS,
  VEHICLE_DETAILS_FAIL,
  VEHICLE_DETAILS_SUCCESS,
  ADD_VEHICLE,
  ADD_VEHICLE_SUCCESS,
  ADD_VEHICLE_FAIL,
  VEHICLES_LIST,
  VEHICLES_LIST_SUCCESS,
  VEHICLES_LIST_FAIL,
  DELETE_VEHICLE,
  DELETE_VEHICLE_SUCCESS,
  DELETE_VEHICLE_FAIL,
  VEHICLE_HISTORY,
  VEHICLE_HISTORY_FAIL,
  VEHICLE_HISTORY_SUCCESS,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_FAIL,
  ADD_VEHICLE_ATTACHMENT,
  ADD_VEHICLE_ATTACHMENT_SUCCESS,
  ADD_VEHICLE_ATTACHMENT_FAIL,
  GET_VEHICLE_LOGS,
  GET_VEHICLE_LOGS_SUCCESS,
  GET_VEHICLE_LOGS_FAIL,
} from "./actionTypes";

export const addVehicleAttachment = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_VEHICLE_ATTACHMENT,
  payload: { data, onSuccess, onError },
});
export const addVehicleAttachmentSuccess = data => ({
  type: ADD_VEHICLE_ATTACHMENT_SUCCESS,
  payload: data,
});
export const addVehicleAttachmentFail = error => ({
  type: ADD_VEHICLE_ATTACHMENT_FAIL,
  payload: error,
});

export const deleteAttachment = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_ATTACHMENT,
  payload: { data, onSuccess, onError },
});
export const deleteAttachmentSuccess = data => ({
  type: DELETE_ATTACHMENT_SUCCESS,
  payload: data,
});
export const deleteAttachmentFail = error => ({
  type: DELETE_ATTACHMENT_FAIL,
  payload: error,
});

export const getVehicleHistory = data => ({
  type: VEHICLE_HISTORY,
  payload: data,
});
export const getVehicleHistorySuccess = data => ({
  type: VEHICLE_HISTORY_SUCCESS,
  payload: data,
});
export const getVehicleHistoryFail = error => ({
  type: VEHICLE_HISTORY_FAIL,
  payload: error,
});

export const getvehicles = (data = {}) => ({
  type: VEHICLES_LIST,
  payload: data,
});
export const getvehiclesSuccess = data => ({
  type: VEHICLES_LIST_SUCCESS,
  payload: data,
});
export const getvehiclesFail = error => ({
  type: VEHICLES_LIST_FAIL,
  payload: error,
});

export const getVehicleLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_VEHICLE_LOGS,
  payload: { data, onSuccess, onError },
});
export const getVehicleLogsSuccess = data => ({
  type: GET_VEHICLE_LOGS_SUCCESS,
  payload: data,
});
export const getVehicleLogsFail = error => ({
  type: GET_VEHICLE_LOGS_FAIL,
  payload: error,
});

export const addVehicle = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_VEHICLE,
  payload: { data, onSuccess, onError },
});
export const addVehicleSuccess = data => ({
  type: ADD_VEHICLE_SUCCESS,
  payload: data,
});
export const addVehicleFail = error => ({
  type: ADD_VEHICLE_FAIL,
  payload: error,
});
export const getVehicleDetail = data => ({
  type: VEHICLE_DETAILS,
  payload: data,
});
export const getVehicleDetailSuccess = data => ({
  type: VEHICLE_DETAILS_SUCCESS,
  payload: data,
});
export const getVehicleDetailFail = error => ({
  type: VEHICLE_DETAILS_FAIL,
  payload: error,
});
export const updateVehicle = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_VEHICLE,
  payload: { data, onSuccess, onError },
});
export const updateVehicleSuccess = data => ({
  type: UPDATE_VEHICLE_SUCCESS,
  payload: data,
});
export const updateVehicleFail = error => ({
  type: UPDATE_VEHICLE_FAIL,
  payload: error,
});
export const deleteVehicle = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_VEHICLE,
  payload: { data, onSuccess, onError },
});
export const deleteVehicleSuccess = data => ({
  type: DELETE_VEHICLE_SUCCESS,
  payload: data,
});
export const deleteVehicleFail = error => ({
  type: DELETE_VEHICLE_FAIL,
  payload: error,
});
